import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { CONSTANTS } from '../../../constants/constants';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/system/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import StickyNoteIcon from '../../../NRIcons/StickyNoteIcon';
import moment from 'moment';

const { HEADER } = CONSTANTS.DATE_FORMAT;

const UserModificationFormatter = ({ row }) => {
  const theme = useTheme();
  const { latestRemediation } = row;

  if (!latestRemediation || Object.values(latestRemediation).every(item => item == null || item == 'IdentificationRemediation')) return null;
  const { author, reason, remediationAction, createdAt, operationId, operationType, identificationId } = row?.latestRemediation || {};

  const TooltipContent = () => (
    <Box m={0.5}>
      {!!reason && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Detail'} />
          <Typography variant="caption" children={reason} />
        </Box>
      )}
      {!!createdAt && (
        <Box display="flex" flexDirection="column" mb={1.5}>
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Updated On'} />
          <Typography variant="caption" children={moment(createdAt).format(HEADER)} />
        </Box>
      )}
      {!!author && (
        <Box display="flex" flexDirection="column">
          <Typography variant="caption" fontWeight={theme.typography.fontWeightBold} children={'Updated By'} />
          <Typography variant="caption" children={author} />
        </Box>
      )}
    </Box>
  );

  return (
    <Tooltip placement="left" title={!!reason || !!createdAt || !!author ? <TooltipContent /> : null}>
      <Box display={'flex'} alignItems={'center'} justifyContent={'center'}>
        <StickyNoteIcon color={theme.palette.text.iconInfo} fillOpacity={1} />
      </Box>
    </Tooltip>
  );
};

export const NRUserModificationProvider = props => <DataTypeProvider formatterComponent={UserModificationFormatter} {...props} />;
